import { TeamDomainInsertModelSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { GetTeamOutputSchema } from './get-team.models.ts'

export const CreateTeamInputSchema = TeamDomainInsertModelSchema.pick({
  organizationType: true,
  organizationId: true,
  name: true,
  billingProfileId: true,
}).partial({
  billingProfileId: true,
})

export type CreateTeamInput = ZodInfer<typeof CreateTeamInputSchema>

export const CreateTeamOutputSchema = GetTeamOutputSchema

export type CreateTeamOutput = ZodInfer<typeof CreateTeamOutputSchema>
